// Propósito: helpers puros del interceptor de autenticación.
import { HttpErrorResponse } from '@angular/common/http';

// Indica si existe token para anexar.
export function hasToken(token: unknown): boolean {
  return Boolean(token);
}

// Detecta respuesta no autorizada.
export function isUnauthorized(error: HttpErrorResponse): boolean {
  return error.status === 401;
}

// Indica si la llamada establece la sesión (su 401 lo maneja el flujo con tope).
export function isSessionCall(url: string): boolean {
  return url.includes('decrypt-token');
}
